import React__default from 'react';

var UserBlockRow = function (_a) {
    var children = _a.children, _b = _a.isHighlighted, isHighlighted = _b === void 0 ? false : _b;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "user-row ".concat(isHighlighted ? 'highlight' : '') }, children),
        React__default.createElement("div", { className: 'for-highlight' })));
};

export { UserBlockRow };
